import React from "react";
import AddChoferForm from "./AddChoferForm";

const AddChofer = ({ show, setShow }) => {
  const handleShow = () => {
    setShow(!show);
  };
  return (
    <>
      <div className="">
        <button className="btn btn-dark" onClick={handleShow}>
          {show ? "Ocultar Form" : "Agregar Chofer"}
        </button>
      </div>
      {show && (
        <div className="mt-2">
          <AddChoferForm setShow={setShow} />
        </div>
      )}
    </>
  );
};
export default AddChofer;
